import type { ReactNode } from 'react';
import { Button } from '@mui/material';

import { LIST } from './tokens';

export function TextButton({
  label,
  onClick,
  startIcon,
  endIcon,
}: {
  label: string;
  onClick: () => void;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}) {
  return (
    <Button
      variant="text"
      disableRipple
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        minWidth: 0,
        p: '4px',
        m: '-4px',
        color: LIST.primary,
        fontFamily: LIST.font,
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '20px',
        letterSpacing: '0.0313em',
        textTransform: 'none',
        '& .MuiButton-startIcon, & .MuiButton-endIcon': { m: 0, mr: startIcon ? '4px' : 0, ml: endIcon ? '4px' : 0 },
        '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
      }}
    >
      {label}
    </Button>
  );
}
